// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"120":"48efa585","136":"fb0e5606","188":"c2c912a9","453":"3eff7996","708":"c938d515","946":"39c3c903"}[chunkId] + ".chunk.js";
};